import { backendServices, ICustomerViewModel, RecursivePartial } from 'common';

/**
 * Mirrors the per-supplier `dbo.Customer` row created by the nightly job in
 * `Transcepta.DocumentProcessing.Rules/SupplierSIMRequestCreation.cs`. The
 * `CustomerNumber` is the dedupe key both sides match on, so whichever runs
 * first wins and the other reuses the row.
 */

export function buildSimCustomerNumber(args: {
    buyerTransceptaCustomerId: number;
    simDocumentTypeDescription: string;
}): string {
    return `${args.buyerTransceptaCustomerId}-${args.simDocumentTypeDescription}`;
}

export function findExistingSimCustomer(
    customers: ICustomerViewModel[],
    expectedCustomerNumber: string
): ICustomerViewModel | null {
    return customers.find((c) => c.CustomerNumber === expectedCustomerNumber) ?? null;
}

export function buildSimCustomerViewModel(args: {
    supplierCompanyId: number;
    schedule: backendServices.ViewModels.SIMDocumentTypeScheduleViewModel;
    buyer: { Name: string; Address1: string; TransceptaCustomerID: number };
    buyerDestinationProfileId: number;
}): RecursivePartial<ICustomerViewModel> {
    const customerNumber = buildSimCustomerNumber({
        buyerTransceptaCustomerId: args.buyer.TransceptaCustomerID,
        simDocumentTypeDescription: args.schedule.Description,
    });

    return {
        CompanyID: args.supplierCompanyId,
        CustomerNumber: customerNumber,
        Name: args.buyer.Name,
        AddressBlock: args.buyer.Address1,
        Phone: '',
        Fax: '',
        AllowMarketingMaterial: false,
        // CustomerPaymentType.All
        PaymentType: 4,
        MaxEmailSize: 1024,
        // Diverges from the nightly job, which sets the trading partner's
        // DefaultVendorNumber; post-signup has no trading partner lookup.
        VendorNumber: null as unknown as string,
        // CustomerDeliverySetting.UseCustomer
        DeliverySetting: 2,
        // TradingPartnerStatus.Active
        Status: 1,
        ShipToAddressBlock: null as unknown as string,
        DefaultCurrency: 1,
        ProcurementProfileId: args.schedule.ProcurementProfileId ?? undefined,
        BuyerDestinationProfileId: args.buyerDestinationProfileId,
        CaseNum: null as unknown as string,
    };
}
